import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { GoToLogo as GoToLogoUi } from '@olo-web/assets/images/GoToLogo.ui';
import { useMerchantPath } from '@olo-web/domain/merchants/hooks/useMerchantPath';
import React from 'react';

export const GoToBanner = () => {
  const merchantPath = useMerchantPath();
  const goToUrl = `${merchantPath}/app/goto`;

  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      padding="1rem"
      backgroundColor="gray.100"
      borderRadius="md"
      boxShadow="md"
    >
      <Box flex="0 0 auto">
        <GoToLogoUi w="56px" h="56px" />
      </Box>
      <Text
        flex="1"
        textAlign="left"
        fontSize="var(--font-size-100, 16px)"
        fontWeight="600"
        mx="2rem"
      >
        Download for a quicker way to reorder
      </Text>
      <Box flex="0 0 auto">
        <Button
          as="a"
          href={goToUrl}
          target="_blank"
          rel="noopener noreferrer"
          background="#0D0A2E"
          size="md"
          height="30px"
          borderRadius="var(--Radius-radius-full, 96px)"
          aria-label="Open the GoTo app (opens in new window)"
        >
          Open
        </Button>
      </Box>
    </Flex>
  );
};
